/**
 * Copyright (C) 2023 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React, { useMemo } from 'react';
import { ListItemText } from '@mui/material';
import Terminal from '../../shared/entities/terminal';
import { valueOrPlaceholder } from '../../utils/StringUtils';
import {
  getBeamDisplayText,
  getTxPowerAndSiteIdText,
} from '../../utils/TerminalListDrawerUtils';

const PlatformListListItemDataLinkway = (props: {
  terminal: Terminal;
  classes: any;
}) => {
  const { terminal, classes } = props;

  const leftListItemText = useMemo(
    () => (
      <ListItemText
        data-test="terminal-list-item-text__left-column"
        classes={{
          primary:
            terminal.connectivityStatus !== 'offline'
              ? terminal.connectivityStatus === 'active'
                ? classes.leftPrimaryActive
                : classes.leftPrimaryStandby
              : classes.leftPrimaryOffline,
          secondary: classes.leftSecondary,
          multiline: classes.leftMultiline,
        }}
        primary={
          <span data-test="terminal-list-item-text__left-column__lw-terminal-status">
            {`${valueOrPlaceholder(terminal.networkOrigin)} : ${getBeamDisplayText(terminal)}`}
          </span>
        }
        secondary={
          <span data-test="terminal-list-item-text__left-column__lw-txpower-siteid">
            {getTxPowerAndSiteIdText(terminal)}
          </span>
        }
      />
    ),
    [terminal, classes],
  );

  return (
    <React.Fragment>
      {leftListItemText}
    </React.Fragment>
  );
};

export default PlatformListListItemDataLinkway;
